import { render, staticRenderFns } from "./ModalBankingServicesComponent.vue?vue&type=template&id=76c8167d"
import script from "./ModalBankingServicesComponent.vue?vue&type=script&lang=js"
export * from "./ModalBankingServicesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports